<app-header></app-header>

<div class="p-4">
  <div class="flex items-center gap-3 mb-5 pl-3 border-l-4 border-ag-red">
    <div>
      <h2 class="text-lg font-bold text-gray-900 m-0">Bulletins de paie</h2>
      <p class="text-xs text-gray-400 m-0">Génération de la paie avec calcul automatique des retenues (CNSS, ITS)</p>
    </div>
  </div>

  <div class="rounded-xl border border-gray-100 bg-white shadow-sm overflow-hidden">
    <div class="flex flex-wrap items-center gap-2 px-4 py-3 border-b border-gray-100 bg-gray-50">
      <button (click)="add(formContent)" class="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-ag-red hover:bg-ag-red-alt text-white text-sm font-semibold transition-colors">+ Générer un bulletin</button>
      <button (click)="show(detailContent)" class="px-3 py-1.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 text-sm">Détail</button>
      <button (click)="delete()" class="px-3 py-1.5 rounded-lg border border-ag-red text-ag-red hover:bg-ag-red hover:text-white text-sm transition-colors">Supprimer</button>
      <div class="ml-auto">
        <input type="text" [(ngModel)]="search_text" placeholder="Rechercher..." class="border border-gray-200 rounded-lg px-3 py-1.5 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10 w-56">
      </div>
    </div>

    <app-loading [isVisible]="loading"></app-loading>

    <div class="overflow-x-auto">
      <table class="w-full text-sm">
        <thead>
          <tr class="bg-gray-50 text-start text-xs text-gray-400 uppercase tracking-wide">
            <th class="px-3 py-2 w-8"></th>
            <th class="px-3 py-2">Employé</th>
            <th class="px-3 py-2">Période</th>
            <th class="px-3 py-2 text-end">Brut</th>
            <th class="px-3 py-2 text-end">Retenues</th>
            <th class="px-3 py-2 text-end">Net à payer</th>
            <th class="px-3 py-2 text-center">Statut</th>
          </tr>
        </thead>
        <tbody>
          @for (d of data | sampleSearch:search_text:'period' | paginate:{id:'spPg', itemsPerPage:pg.pageSize, currentPage:pg.p, totalItems:pg.total}; track d.id) {
            <tr class="border-t border-gray-50 hover:bg-red-50/30">
              <td class="px-3 py-2"><input type="radio" [checked]="selected_data?.id === d.id" name="spRadio" (click)="checked(d)" class="accent-ag-red"></td>
              <td class="px-3 py-2 font-semibold text-gray-800">{{personalName(d.personal)}}</td>
              <td class="px-3 py-2 text-gray-500">{{d.period}}</td>
              <td class="px-3 py-2 text-end">{{d.gross_salary | number}} F</td>
              <td class="px-3 py-2 text-end text-ag-red">− {{d.total_deductions | number}} F</td>
              <td class="px-3 py-2 text-end font-bold text-green-700">{{d.net_salary | number}} F</td>
              <td class="px-3 py-2 text-center">
                <span class="px-2 py-0.5 rounded-full text-xs font-semibold" [ngClass]="statusClass(d.status)">{{statusLabel(d.status)}}</span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    @if (!loading && data.length === 0) { <p class="text-center text-gray-400 py-8 text-sm">Aucun bulletin de paie.</p> }
    <div class="flex justify-center py-3"><pagination-controls id="spPg" (pageChange)="getPage($event)" [previousLabel]="'Précédent'" [nextLabel]="'Suivant'" [autoHide]="true"></pagination-controls></div>
  </div>
</div>

<!-- Modal génération bulletin -->
<ng-template #formContent let-d="dismiss">
  <div class="flex items-center justify-between px-5 py-3 border-b border-gray-100 border-l-4 border-l-ag-red">
    <h5 class="font-bold text-gray-900 m-0">Générer un bulletin de paie</h5>
    <button type="button" (click)="d('x')" class="w-7 h-7 rounded-full hover:bg-gray-100 text-gray-400">✕</button>
  </div>
  <form #f="ngForm" (ngSubmit)="store(form)">
    <div class="p-5 grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Employé *</label>
        <select name="personal_id" [(ngModel)]="form.personal_id" required class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
          <option [ngValue]="null">— Choisir —</option>
          @for (p of personals; track p.id) { <option [ngValue]="p.id">{{p.firstname}} {{p.lastname}}</option> }
        </select>
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Période (mois) *</label>
        <input name="period" type="month" [(ngModel)]="form.period" required class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
      </div>
      <div class="md:col-span-2">
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Grille salariale (pré-remplissage)</label>
        <select name="salary_grid_id" [(ngModel)]="form.salary_grid_id" (ngModelChange)="onGridChange()" class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
          <option [ngValue]="null">— Saisie manuelle —</option>
          @for (g of grids; track g.id) { <option [ngValue]="g.id">{{g.label}} ({{g.base_salary | number}} F)</option> }
        </select>
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Salaire de base *</label>
        <input name="base_salary" type="number" min="0" [(ngModel)]="form.base_salary" (ngModelChange)="recompute()" required class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Primes</label>
        <input name="allowances" type="number" min="0" [(ngModel)]="form.allowances" (ngModelChange)="recompute()" class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Autres retenues</label>
        <input name="other_deductions" type="number" min="0" [(ngModel)]="form.other_deductions" (ngModelChange)="recompute()" class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Mode de paiement</label>
        <select name="payment_method" [(ngModel)]="form.payment_method" class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
          @for (m of PAYMENT_METHODS; track m) { <option [value]="m">{{m}}</option> }
        </select>
      </div>

      <!-- Aperçu calcul -->
      @if (calc) {
        <div class="md:col-span-2 rounded-lg bg-gray-50 border border-gray-100 p-4">
          <p class="text-xs font-bold uppercase text-gray-400 mb-2">Aperçu du bulletin</p>
          <div class="grid grid-cols-2 gap-y-1.5 text-sm">
            <span class="text-gray-600">Salaire brut</span><span class="text-end font-semibold">{{calc.gross_salary | number}} F</span>
            <span class="text-gray-600">CNSS (3,6%)</span><span class="text-end text-ag-red">− {{calc.cnss | number}} F</span>
            <span class="text-gray-600">ITS (impôt)</span><span class="text-end text-ag-red">− {{calc.its | number}} F</span>
            @if (calc.other_deductions > 0) {
              <span class="text-gray-600">Autres retenues</span><span class="text-end text-ag-red">− {{calc.other_deductions | number}} F</span>
            }
            <span class="text-gray-800 font-bold border-t border-gray-200 pt-1.5 mt-1">Net à payer</span>
            <span class="text-end font-bold text-green-700 border-t border-gray-200 pt-1.5 mt-1">{{calc.net_salary | number}} F</span>
          </div>
        </div>
      }
    </div>
    <div class="flex justify-end gap-2 px-5 py-3 border-t border-gray-100 bg-gray-50">
      <button type="button" (click)="d('x')" class="px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 text-sm">Annuler</button>
      <button type="submit" [disabled]="f.invalid || loading" class="px-4 py-2 rounded-lg bg-ag-red hover:bg-ag-red-alt text-white text-sm font-semibold disabled:opacity-50 inline-flex items-center gap-2">Générer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
  </form>
</ng-template>

<!-- Modal détail bulletin -->
<ng-template #detailContent let-d="dismiss">
  <div class="flex items-center justify-between px-5 py-3 border-b border-gray-100 border-l-4 border-l-ag-red">
    <h5 class="font-bold text-gray-900 m-0">Bulletin de paie</h5>
    <button type="button" (click)="d('x')" class="w-7 h-7 rounded-full hover:bg-gray-100 text-gray-400">✕</button>
  </div>
  @if (selected_data) {
    <div class="p-5">
      <div class="flex justify-between mb-4">
        <div>
          <p class="font-bold text-gray-900 m-0">{{personalName(selected_data.personal)}}</p>
          <p class="text-xs text-gray-400 m-0">Période : {{selected_data.period}}</p>
        </div>
        <span class="px-2 py-0.5 rounded-full text-xs font-semibold h-fit" [ngClass]="statusClass(selected_data.status)">{{statusLabel(selected_data.status)}}</span>
      </div>
      <div class="grid grid-cols-2 gap-y-2 text-sm border-t border-gray-100 pt-3">
        <span class="text-gray-600">Salaire de base</span><span class="text-end">{{selected_data.base_salary | number}} F</span>
        <span class="text-gray-600">Primes</span><span class="text-end">{{selected_data.allowances | number}} F</span>
        <span class="text-gray-800 font-semibold">Salaire brut</span><span class="text-end font-semibold">{{selected_data.gross_salary | number}} F</span>
        <span class="text-gray-600">CNSS</span><span class="text-end text-ag-red">− {{selected_data.cnss | number}} F</span>
        <span class="text-gray-600">ITS</span><span class="text-end text-ag-red">− {{selected_data.its | number}} F</span>
        @if (selected_data.other_deductions > 0) {
          <span class="text-gray-600">Autres retenues</span><span class="text-end text-ag-red">− {{selected_data.other_deductions | number}} F</span>
        }
        <span class="text-gray-800 font-bold border-t border-gray-200 pt-2">Net à payer</span>
        <span class="text-end font-bold text-green-700 border-t border-gray-200 pt-2">{{selected_data.net_salary | number}} F</span>
      </div>
      <div class="flex gap-2 mt-5 flex-wrap">
        @if (selected_data.status == 2) {
          <button (click)="setStatus(1)" class="px-3 py-1.5 rounded-lg bg-green-600 hover:bg-green-700 text-white text-sm">✓ Marquer payé</button>
        }
        @if (selected_data.status != 0) {
          <button (click)="setStatus(0)" class="px-3 py-1.5 rounded-lg border border-ag-red text-ag-red hover:bg-ag-red hover:text-white text-sm">Annuler le bulletin</button>
        }
      </div>
    </div>
  }
</ng-template>
